import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-hightlighted-bg',
  templateUrl: './hightlighted-bg.component.html',
  styleUrls: ['./hightlighted-bg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HightlightedBgComponent {}
